import { render, staticRenderFns } from "./card-count.vue?vue&type=template&id=2a2a3521&"
import script from "./card-count.vue?vue&type=script&lang=js&"
export * from "./card-count.vue?vue&type=script&lang=js&"
import style0 from "./card-count.vue?vue&type=style&index=0&id=2a2a3521&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports